import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "map-component" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_MapPopup = _resolveComponent("MapPopup")!
  const _component_MapLegend = _resolveComponent("MapLegend")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "map-component__state",
          style: _normalizeStyle(_ctx.getSizeStyle)
        }, [
          _createVNode(_component_Loader)
        ], 4))
      : (_ctx.stateMessage)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "map-component__state",
            style: _normalizeStyle(_ctx.getSizeStyle)
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.stateMessage), 1)
          ], 4))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.popupOpen)
              ? (_openBlock(), _createBlock(_component_MapPopup, {
                  key: 0,
                  onClosePopup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closePopup')))
                }, {
                  header: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "popupHeader", {}, undefined, true)
                  ]),
                  body: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "popupBody", {}, undefined, true)
                  ]),
                  _: 3
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              ref: "container",
              class: "map-component__canvas",
              style: _normalizeStyle(_ctx.getSizeStyle)
            }, null, 4),
            (_ctx.legend)
              ? (_openBlock(), _createBlock(_component_MapLegend, {
                  key: 1,
                  title: _ctx.legend.title,
                  background: _ctx.legend.background,
                  marks: _ctx.legend.marks
                }, null, 8, ["title", "background", "marks"]))
              : _renderSlot(_ctx.$slots, "legend", { key: 2 }, undefined, true)
          ], 64))
  ]))
}